var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "v-card--dialog v-card--dialog--sm"
  }, [_c('div', {
    staticClass: "v-card--dialog__head"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("현금영수증 신청")]), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm.order ? _c('div', {
    staticClass: "d-inline-flex flex-wrap align-center font-size-14 line-height-1"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-col', [_c('v-checkbox', {
    staticClass: "ma-0",
    attrs: {
      "value": true,
      "hide-details": "",
      "label": "현금영수증 신청"
    },
    model: {
      value: _vm.order.cashbill.status,
      callback: function callback($$v) {
        _vm.$set(_vm.order.cashbill, "status", $$v);
      },
      expression: "order.cashbill.status"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "disabled": !_vm.order.cashbill.status
    },
    model: {
      value: _vm.order.cashbill.tradeUsage,
      callback: function callback($$v) {
        _vm.$set(_vm.order.cashbill, "tradeUsage", $$v);
      },
      expression: "order.cashbill.tradeUsage"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "개인 소득 공제",
      "value": "소득공제용"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "사업자 지출 증빙",
      "value": "지출증빙용"
    }
  })], 1), _vm.order.cashbill.tradeUsage === '소득공제용' ? _c('v-select', {
    attrs: {
      "disabled": !_vm.order.cashbill.status,
      "items": _vm.items,
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.cashbillType,
      callback: function callback($$v) {
        _vm.cashbillType = $$v;
      },
      expression: "cashbillType"
    }
  }) : _vm._e(), _c('v-text-field', {
    attrs: {
      "placeholder": _vm.displayCashbillPlaceholder,
      "disabled": !_vm.order.cashbill.status,
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.cashbill.identityNum,
      callback: function callback($$v) {
        _vm.$set(_vm.order.cashbill, "identityNum", $$v);
      },
      expression: "order.cashbill.identityNum"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "v-card--dialog__foot"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.cashbill
    }
  }, [_vm._v("신청")])], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }